
import { TheCode } from "../../Common/CommonSteps";
import AppSvc from "../../../services/app-svc";

let service = null;

export default {
  name: "the-selection",
  components: {
    TheCode,
  },
  props: {
    isTpn: {
      type: Boolean,
      required: true,
    },
    tpnChainId: {
      type: Number,
      required: true,
    },
    tpnSiteId: {
      type: Number,
      required: true,
    },
    useAxios: Boolean,
    apiUrl: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    clientIdentity: {
      type: String,
      required: true,
    },
    username: {
      type: String,
      required: false,
    },
    vippsEmail: {
      type: String,
      required: false,
      default: "",
    },
    layout: {
      type: String,
      required: false,
      default: "chain",
    },
  },
  data() {
    return {
      currentForm: "verify-email",
      previousForm: "",
      code: "",
      showResendText: false,
      error: "",
    };
  },
  computed: {
    origin(){
      return localStorage.getItem('origin') ?? ''
    }
  },
  methods: {
    setCode(value) {
      this.code = value;
    },
    resetError() {
      this.error = "";
    },
    changeView(state) {
      this.$emit("changeView", state);
    },
    close() {
      this.$emit("close");
    },
    VerifyAndLogin(reuseEmail) {
      var body = {
        username: this.username || this.email,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.currentForm,
        clientIdentity: this.clientIdentity,
        code: this.code,
        email: this.email,
        vippsEmail: this.vippsEmail,
      };
      service.VerifyAndLogin(this.apiUrl, body, reuseEmail).then((response) => {
        if (response.data.responseCode === 200) {
          var result = response.data;
          this.email = result.fixitNoUser?.email
            ? result.fixitNoUser?.email
            : this.email;
          this.clientIdentity = result.clientIdentity;
          this.previousForm = this.currentForm;
          this.currentForm = result.nextStep;
          if (result.nextStep === "welcome-screen") {
            this.$emit("setUser", result.fixitNoUser);
          }
        } else {
          this.showResendText = false;
          this.error = response.data.responseMessage;
        }
      });
    },
    resendCode() {
      var body = {
        username: this.username,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.currentForm,
        email: this.email,
        resendCode: 'true'
      };

      service.VerifyLoginStep(this.apiUrl, body).then((response) => {
        this.showResendText = true;
        if (response.data.responseCode === 200) {
          var result = response.data;
          this.clientIdentity = result.clientIdentity;
        }
      });
    },
  },
  async created() {
    service = await AppSvc(this.useAxios ? this.$axios : null);
  },
};
